module.exports = __webpack_public_path__ + "img/38301-021.d93b86d5.jpg";